import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { ConfirmDialog, UiModal } from 'shared/ui';
import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';

import { CarDto, useDeleteCarMutation } from 'entities/car';

import { DELETE_ERROR, DELETE_SUCCESS } from '../../consts';

type Props = {
  personLogin: string;
  car: CarDto;
};

export const DeleteCarModal = NiceModal.create((props: Props) => {
  const modal = useModal();

  const [trigger, { isLoading }] = useDeleteCarMutation();

  const {
    car: { id, name },
    personLogin,
  } = props;

  const handleDelete = async () => {
    try {
      const res = await trigger({ id: String(id), personLogin }).unwrap();

      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);
        return;
      }

      openSuccessNotification(DELETE_SUCCESS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : DELETE_ERROR;

      openErrorNotification(errorText);
    } finally {
      modal.hide();
    }
  };

  return (
    <UiModal
      title={`Удалить автомобиль "${name}"?`}
      visible={modal.visible}
      onCancel={modal.hide}
      afterClose={modal.remove}
    >
      <ConfirmDialog
        onCancel={modal.hide}
        onConfirm={() => handleDelete()}
        loading={isLoading}
      />
    </UiModal>
  );
});
